// extracted by mini-css-extract-plugin
export default {"container":"GeneralInformation_container__MUCLa","s-h3":"GeneralInformation_s-h3__PMDjF"};